import { ClickTracking } from './tracking/shared/click-tracking';
import { ViewTracking } from './tracking/shared/view-tracking';

const initUiTracking = () => {
	new ClickTracking();
	new ViewTracking();
};

if (/complete|interactive|loaded/.test(document.readyState)) {
	initUiTracking();
} else {
	document.addEventListener('DOMContentLoaded', () => initUiTracking());
}
